import {
    MESSAGE_TEMPLATE_CREATE_EDIT_OPEN_MODAL,
    MESSAGE_TEMPLATE_CREATE_REQUEST,
    MESSAGE_TEMPLATE_CREATE_RESULT,
    MESSAGE_TEMPLATE_EDIT_REQUEST,
    MESSAGE_TEMPLATE_EDIT_RESULT,
    MESSAGE_TEMPLATE_GET_REQUEST,
    MESSAGE_TEMPLATE_GET_RESULT,
} from 'Redux/actionTypes';

export const messageTemplateCreateEditOpenModal = (open, messageTemplate) => ({
    type: MESSAGE_TEMPLATE_CREATE_EDIT_OPEN_MODAL,
    payload: { open, messageTemplate }
})

export const messageTemplateCreateRequest = (data) => ({
    type: MESSAGE_TEMPLATE_CREATE_REQUEST,
    payload: data
})

export const messageTemplateCreateResult = (result) => ({
    type: MESSAGE_TEMPLATE_CREATE_RESULT,
    payload: result
})

export const messageTemplateEditRequest = (data) => ({
    type: MESSAGE_TEMPLATE_EDIT_REQUEST,
    payload: data
})

export const messageTemplateEditResult = (result) => ({
    type: MESSAGE_TEMPLATE_EDIT_RESULT,
    payload: result
})

export const messageTemplateGetRequest = (data) => ({
    type: MESSAGE_TEMPLATE_GET_REQUEST,
    payload: data
})

export const messageTemplateGetResult = (result) => ({
    type: MESSAGE_TEMPLATE_GET_RESULT,
    payload: result
})